export const WelcomeStepWorkout = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&',
  },

  template: `
    <div class="welcome-step-workout">
      <h1 class="h2 text-center text-white my-4">
        Your Workout Profile
      </h1>
      <section class="theme-light p-3 mb-5">
        <form class="voome-form voome-form--workout"
          name="form"
          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"
          novalidate>
          <speech-bubble-workout
            form="form"
            member="$ctrl.member"
            scroll-to="$ctrl.scrollTo({ id: id })"
            on-complete="$ctrl.isComplete = true"
            on-update="$ctrl.onUpdate({ key: key, value: value })">
          </speech-bubble-workout>
          <div class="d-flex justify-content-center pt-4"
            ng-show="$ctrl.isComplete">
            <ng-transclude></ng-transclude>
          </div>
        </form>
      </section>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepWorkout.js